import { fromJS } from 'immutable';

export default {
    setIssues: (state, issues, currentPage, nextPage, totalPages) => {
        return state
            .set('currentPage', currentPage)
            .set('nextPage', nextPage)
            .set('totalPages', totalPages)
            .mergeIn(['list'], fromJS(issues))
            .set('initialized', true);
    },
    setIssue: (state, issue) => {
        return state.mergeIn(['list'], fromJS(issue));
    }
};



// WEBPACK FOOTER //
// ./environments/ticketsgit/data/Issues/core.js